const DEFAULT_CONFIRM_TEXT = 'Confirm'
const DEFAULT_CANCEL_TEXT = 'Cancel'
const DEFAULT_MESSAGE = 'Are you sure?'

Turbo.config.forms.confirm = (message, _element, submitter) => {
  const confirmText = typeof submitter !== 'undefined' ? submitter.dataset.turboConfirmPositiveText : DEFAULT_CONFIRM_TEXT
  const cancelText = typeof submitter !== 'undefined' ? submitter.dataset.turboConfirmNegativeText : DEFAULT_CANCEL_TEXT

  return confirm(message, confirmText, cancelText)
}

export function confirm (message = DEFAULT_MESSAGE, confirmText = DEFAULT_CONFIRM_TEXT, cancelText = DEFAULT_CANCEL_TEXT, title = null) {
  const dialogHTML = `
    <dialog 
      id="turbo-confirm"
      class="inset-0 max-w-[700px] m-auto p-6 border-0 backdrop:fixed backdrop:inset-0 backdrop:bg-[rgba(0,0,0,0.6)]">
      <form method="dialog">
        <p>${message}</p>
        <fieldset class="flex justify-end gap-x-4 mt-4 pt-3 border-black border-t-[length:var(--line-width)]">
          <button value="cancel" class="underline">${cancelText}</button>
          <button value="confirm" class="underline">${confirmText}</button>
        </fieldset>
      </form>
    </dialog>
  `
  document.body.insertAdjacentHTML('beforeend', dialogHTML)

  const dialog = document.getElementById('turbo-confirm')

  dialog.showModal()

  return new Promise((resolve, reject) => {
    dialog.addEventListener(
      'close',
      () => {
        if (dialog.returnValue == 'confirm') {
          resolve(true)
        }
        dialog.remove()
      },
      { once: true }
    )
  })
}
